import {DevelopmentItemParams, DevelopmentPageLineParams} from "../types/development-page.types";

export const urls: Array<DevelopmentPageLineParams> = [
  {
    title: 'Swagger:',
    type: 'link'
  },
  {
    title: 'Trello:',
    href: 'https://trello.com/b/Vh1RRgK9/%D0%B4%D0%BE%D1%81%D0%BA%D0%B0-%D0%B8%D1%82',
    text: 'https://trello.com/b/Vh1RRgK9/%D0%B4%D0%BE%D1%81%D0%BA%D0%B0-%D0%B8%D1%82',
    type: 'link'
  },
  {
    title: 'Github Frontend:',
    href: 'https://github.com/OOO-MK-CRM/easyclean-frontend',
    text: 'https://github.com/OOO-MK-CRM/easyclean-frontend',
    type: 'link'
  },
  {
    title: 'Github Backend:',
    href: 'https://github.com/OOO-MK-CRM/easyclean-backend',
    text: 'https://github.com/OOO-MK-CRM/easyclean-backend',
    type: 'link'
  },
  {
    title: 'Jenkins:',
    href: 'http://90.156.209.46:8080/',
    text: 'http://90.156.209.46:8080/',
    type: 'link'
  }
]

export const stands: Array<DevelopmentPageLineParams> = [
  {
    title: 'Development:',
    href: 'https://dev.crm-easyclean.ru',
    text: 'https://dev.crm-easyclean.ru',
    type: 'link'
  },
  {
    title: 'Production:',
    href: 'https://crm-easyclean.ru',
    text: 'https://crm-easyclean.ru',
    type: 'link'
  }
]

export const tokens: Array<DevelopmentPageLineParams> = [
  {
    title: 'Roles:',
    type: 'info'
  },
  {
    title: 'Access token:',
    btnText: 'Скопировать',
    type: 'button'
  },
  {
    title: 'Refresh token:',
    btnText: 'Скопировать',
    type: 'button'
  }
]

export const developmentItems: Array<DevelopmentItemParams> = [
  {
    category: 'Токены',
    items: tokens
  },
  {
    category: 'Ссылки',
    items: urls
  },
  {
    category: 'Стенды',
    items: stands
  }
]
